import { post, authPost } from "../http_client.js";
import { AuthProvider, LoginRequest, PlayerResponse } from "../dto/auth.dto.js";
import type { PlayerDto } from '../dto/player.dto.js';

export function login( request: LoginRequest ): Promise<PlayerResponse>
{
  return post( 'api/auth/login', request );
}

export async function deleteAccount(): Promise<void>
{
  return authPost<void>( 'api/auth/v2/delete' );
}

export async function disconnectProvider( disconnect_provider: AuthProvider ): Promise<PlayerDto>
{
  return authPost<PlayerDto>( 'api/auth/v2/disconnect', { disconnect_provider } );
}

export async function connectGoogle( google_token: string, resolve?: 'keep_existing' | 'keep_current' ): Promise<PlayerDto>
{
  return authPost<PlayerDto>( 'api/auth/v2/connect-google', { google_token, resolve } );
}

export async function connectFacebook( facebook_token: string, resolve?: 'keep_existing' | 'keep_current' ): Promise<PlayerDto>
{
  return authPost<PlayerDto>( 'api/auth/v2/connect-facebook', { facebook_token, resolve } );
}

export async function connectApple( apple_token: string, resolve?: 'keep_existing' | 'keep_current' ): Promise<PlayerDto>
{
  return authPost<PlayerDto>( 'api/auth/v2/connect-apple', { apple_token, resolve } );
}

export async function transferAccount( discard_provider: AuthProvider, discard_provider_id: string ): Promise<PlayerDto>
{
  return authPost<PlayerDto>( 'api/auth/v2/transfer', { discard_provider, discard_provider_id } );
}
